import { render, staticRenderFns } from "./MatchWinloseSimple.vue?vue&type=template&id=278d2914&"
import script from "./MatchWinloseSimple.vue?vue&type=script&lang=js&"
export * from "./MatchWinloseSimple.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports